/**
 * Responsive Menu functions
 * Use: import { initResponsiveMenu } from "./components/responsivemenu";
 */
export function initResponsiveMenu() {
	const	NavToggleButton		= $("#toggle-responsive-nav"),
			MobileNavContainer	= $("#mobile_nav_container");
	
	// Open Responsive navigation on Navigation Toggle Button
	NavToggleButton.on("click", function () {
		if ($(this).attr("aria-expanded") === "false") {
			$(this).attr("aria-expanded", true);
			RespLangSearchSwitch( true );

		} else {
			$(this).attr("aria-expanded", false);
			RespLangSearchSwitch( false );
		}

		$(this).toggleClass("open");
		MobileNavContainer.toggleClass('open');
	});

	ExpandResponsiveInit();
	ResponsiveLanguage();
}

/**
 * Expands the current menu item and sets correct classes/aria labels to parents
 * And prevent default link behaviour
 */
function ExpandResponsiveInit() {
	const	CurrentMenuItem = $('#menu-responsive-navigation .current-menu-item'),
			CurrentMenuParent = CurrentMenuItem.parent();

	// If current menu item is in top level
	if( CurrentMenuParent.hasClass('nav_container') ) {
		return;

	// If current menu item is in level 1
	} else if( CurrentMenuParent.hasClass('submenu-level-0') ) {
		const	TopItem			= CurrentMenuParent.parent(),
				TopItemExpander = TopItem.find('> .expander');

		TopItemExpander.addClass('is-active').attr("aria-expanded", true);;
		CurrentMenuParent.css("display", "block");

	// If current menu item is in level 2
	} else if( CurrentMenuParent.hasClass('submenu-level-1') ) {
		const	TopItem				= CurrentMenuParent.parent().parent().parent(),
				TopItemExpander		= TopItem.find('> .expander'),
				TopItemSubmenu		= TopItem.find('.submenu-level-0'),
				ParentExpander		= CurrentMenuParent.parent().find( '> .expander' );

		TopItemExpander.addClass('is-active').attr("aria-expanded", true);
		ParentExpander.addClass('is-active').attr("aria-expanded", true);

		TopItemSubmenu.css("display", "block");
		CurrentMenuParent.css("display", "block").addClass('is-open');

	// If current menu item is in level 3
	} else if( CurrentMenuParent.hasClass('submenu-level-2') ) {
		const	TopItem				= CurrentMenuParent.parent().parent().parent().parent().parent(),
				TopItemExpander		= TopItem.find('> .expander'),
				TopItemSubmenu		= TopItem.find('.submenu-level-0'),
				LevelZeroExpander	= TopItem.find('.submenu-level-0 > li > .expander'),
				LevelZeroSubmenu	= TopItem.find('.submenu-level-1'),
				ParentExpander		= CurrentMenuParent.parent().find( '> .expander' );

		TopItemExpander.addClass('is-active').attr("aria-expanded", true);
		LevelZeroExpander.addClass('is-active').attr("aria-expanded", true);
		ParentExpander.addClass('is-active').attr("aria-expanded", true);

		TopItemSubmenu.css("display", "block");
		LevelZeroSubmenu.css("display", "block").addClass('is-open');;
		CurrentMenuParent.css("display", "block");
	
	} else {
		return;
	}
}

/**
 * Add click event to language selector
 * And prevent default link behaviour
 */
function ResponsiveLanguage( ) {
	const languageSelector = $('#language_navigation ul li.menu-item-has-children > a');
	
	languageSelector.on("click", function(e){
		const languageSubMenu = $(this).parent().find('.submenu');
		e.preventDefault();

		$(this).toggleClass('open');
		languageSubMenu.toggleClass('open');
	});
}

/**
 * Switches between language and search icons in header in responsive menu
 * Use: import { RespLangSearchSwitch } from "./components/responsivemenu";
 */
export function RespLangSearchSwitch( bool ) {
	const	SearchButton		= $("#toggle-search-resp"),
			LanguageToggle		= $("#language_navigation"),
			languageSelector	= $('#language_navigation ul li.menu-item-has-children > a'),
			languageSubMenu		= languageSelector.parent().find('.submenu');
	
	if( bool ) {
		SearchButton.addClass( 'hide' );
		LanguageToggle.addClass( 'show' );
		languageSelector.removeClass( 'open' );
		languageSubMenu.removeClass( 'open' );

	} else{
		SearchButton.removeClass( 'hide' );
		LanguageToggle.removeClass( 'show' );
		languageSelector.removeClass( 'open' );
		languageSubMenu.removeClass( 'open' );
	}
	
}